module.exports = __webpack_public_path__ + "img/orexim.3316a64d.jpg";